import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const PageContainer = styled.div`
    width: 100%;
    height: calc(100vh - 45px);
    display: flex;
    flex: 1;
    margin-top: 45px;
`;

// Left container

export const LeftContainer = styled.div`
    width: 30%;
    height: 100%;
    padding: 5px 10px;

    ${media.phone`
        display: none;
    `};
`;

// Right container

export const RightContainer = styled.div`
    width: 70%;
    height: 100%;

    ${media.phone`
        display: none;
    `};
`;

export const MobileContainer = styled.div`
    width: 100%;
    height: 100%;
    display: none;

    ${media.phone`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `};
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/style.js